import { Flex, Icon, Tooltip } from '@chakra-ui/react';
import { Lightning01 } from '@kula-ai/icons/dual-tone/Lightning01';
import type { FlexProps } from '@chakra-ui/react';

export type AutomationBadgeProps = {
  // Hover copy. Omit for a bare, non-interactive badge.
  tooltipLabel?: string;
} & FlexProps;

/**
 * Lightning chip marking stage automation. Badge a stage with an active rule,
 * and only the activities that rule targets — never every card (CORE-4876).
 */
export const AutomationBadge = ({
  tooltipLabel,
  ...flexProps
}: AutomationBadgeProps) => {
  const badge = (
    <Flex
      alignItems="center"
      justifyContent="center"
      bg="pastel-3-light"
      borderRadius="6px"
      h="22px"
      px="2px"
      flexShrink={0}
      data-test-id="automation-lock-indicator"
      {...flexProps}
    >
      <Icon as={Lightning01} width="14px" height="14px" color="pastel-3-dark" />
    </Flex>
  );

  if (!tooltipLabel) return badge;

  return (
    <Tooltip label={tooltipLabel} placement="top" hasArrow shouldWrapChildren>
      {badge}
    </Tooltip>
  );
};
